// extracted by mini-css-extract-plugin
export default {"root":"history_root__-JDxQ","Menu":"history_Menu__M6ywe","contentContainer":"history_contentContainer__HpjTO","emptyContainer":"history_emptyContainer__FP2bC"};